<template>
  <BasicModal
    :title="'起動設定'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="url-container">
      <b-tabs style="background: white;" v-model="activeTab">
        <b-tab-item label="起動場所" class="tab-box">
          <!-- title -->
          <h2 style="text-align: left; margin-top: 4px; margin-left: 4px; font-size: smaller; color: #666;">
            設置先のURLをお選びください。
          </h2>
          <!-- minibot -->
          <div style="width: 100%; text-align: left;">
            <select v-model="miniIDX" class="select" style="margin-top: 4px; margin-bottom: 4px;" v-if="isMiniBot(chatbot)">
              <option v-for="(m, idx) in chatbot.chatbot_mini" :key="idx" :value="idx">
                {{m.name}}
              </option>
            </select>
          </div>
          <!-- tab -->
          <div class="tabs" style="margin: 8px; overflow-x: auto; overflow-y: hidden;">
            <ul>
              <!-- 求人ページ -->
              <li style="margin-bottom: 8px;">
                <a @click="tabIdx = -1;"
                  :style="{'color': tabIdx == -1 ? '#f0f0f0' : '#CC2C98', 'background': tabIdx == -1 ? '#CC2C98' : 'white'}"
                  style="color: white; border: solid thin #CC2C98; background: white; border-radius: 4px; padding: 4px 8px; margin: 0 8px;">
                  <b>求人ページ</b>
                </a>
              </li>
              <!-- カスタムページ -->
              <li style="margin-bottom: 8px;">
                <a @click="tabIdx = -2;"
                  :style="{'color': tabIdx == -2 ? '#f0f0f0' : '#CC2C98', 'background': tabIdx == -2 ? '#CC2C98' : 'white'}"
                  style="color: white; border: solid thin #CC2C98; background: white; border-radius: 4px; padding: 4px 8px; margin: 0 8px;">
                  <b>カスタムページ</b>
                </a>
              </li>
              <!-- ホームページ -->
              <li style="margin-bottom: 8px;" v-for="(sitemapRoot, index) in sitemapRootList" :key="`X-${index}`">
                <a @click="tabIdx=index"
                  :style="{'color': index == tabIdx ? '#f0f0f0' : '#CC2C98', 'background': tabIdx == index ? '#CC2C98' : 'white'}"
                  style="color: white; border: solid thin #CC2C98; background: white; border-radius: 4px; padding: 4px 8px; margin: 0 8px;">
                  <b>{{sitemapRoot.root_url}}</b>
                </a>
              </li>
            </ul>
          </div>
          <!-- pagination 求人ページのみ -->
          <div style="margin-bottom: 16px;" v-if="(tabIdx === -1 && sitemapRecruitList.length > 0) || (tabIdx === -2 && sitemapCustomList.length > 0)">
            <b-pagination
              style="background: #f0f0f0; border-radius: 8px; width: 95%;"
              :total="total"
              :current.sync="pageData.pages"
              :per-page="pageData.per_page">
            </b-pagination>
          </div>
          <template v-if="tabIdx === -2">
            <p style="text-align: left; vertical-align: middle; display: flex; align-items: center; margin-bottom: 16px;">
              <b-checkbox v-model="isAllSelectedCustom" @input="getAllUrl(tabIdx)" :disabled="isContentsLoading"><b>全URLに適用する</b></b-checkbox>
            </p>
          </template>
          <template v-if="tabIdx === -1">
            <p style="text-align: left; vertical-align: middle; display: flex; align-items: center; margin-bottom: 16px;">
              <b-checkbox v-model="isAllSelectedRecruit" @input="getAllUrl(tabIdx)" :disabled="isContentsLoading"><b>全URLに適用する</b></b-checkbox>
            </p>
          </template>
          <template v-if="tabIdx >= 0">
            <p style="text-align: left; vertical-align: middle; display: flex; align-items: center; margin-bottom: 16px;">
              <b-checkbox v-model="isAllSelectedHomePage" @input="getAllUrl(tabIdx)" :disabled="isContentsLoading"><b>全URLに適用する</b></b-checkbox>
            </p>
          </template>
          <div style="position: relative; overflow: auto; max-height: 360px;">
            <!-- ローディングページ -->
            <div class="init-page" style="background: transparent;" v-if="isContentsLoading">
              <span class="mdi mdi-spin mdi-loading mdi-48px"></span>
            </div>
            <div v-if="!isContentsLoading">
              <!-- 求人ページ -->
              <template v-for="(recruit, index) in sitemapRecruitList">
                <p class="url-list" v-if="tabIdx == -1 && recruit.contents.layout == 4"
                  :key="`Z-${index}`"
                  style="text-align: left; vertical-align: middle;">
                  <b-checkbox style="white-space: nowrap;" v-model="selectRecruitList" :native-value="recruit">{{recruit.contents.content.title}}</b-checkbox>
                </p>
              </template>
              <!-- カスタムページ -->
              <template v-for="(custom, index) in sitemapCustomList">
                <p class="url-list" v-if="tabIdx == -2 && custom.contents.layout == 5"
                  :key="`Z-${index}`"
                  style="text-align: left; vertical-align: middle;">
                  <b-checkbox style="white-space: nowrap;" v-model="selectCustomList" :native-value="custom">{{custom.contents.title}}</b-checkbox>
                </p>
              </template>
              <!-- ホームページ -->
              <template v-for="(homepage, index) in sitemapRootList">
                <div v-if="tabIdx >= 0 && tabIdx === index"
                  :key="`Z-${index}`"
                  style="text-align: left; vertical-align: middle;">
                  <template v-for="(node, index2) in homepage.node_list">
                    <p class="url-list" :key="index2">
                      <b-checkbox style="white-space: nowrap;" v-model="selectSitemapList" :native-value="node">{{node.node_url}}</b-checkbox>
                    </p>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="起動時間" class="tab-box">
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p><b>起動時間を設定する</b></p>
            </div>
            <div class="tab-box-right">
              <p style="font-size: 16px"><b>終日</b></p>
              <b-switch style="padding-left: 8px; width: 50%;" size="is-small" v-model="isAllDay">
              </b-switch>
            </div>
            <div class="tab-box-left"></div>
            <div class="tab-box-right">
              <b-timepicker v-model="start" size="is-small" inline :disabled="isAllDay"></b-timepicker>
              <p style="font-size: 24px;margin-left:10px;margin-right:10px;"><b>-</b></p>
              <b-timepicker v-model="end" size="is-small" inline :disabled="isAllDay"></b-timepicker>
            </div>
          </div>
          <div class="dot-line"></div>
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p><b>休日</b>
                <span style="font-size: 12px; color: #666;">
                  <br>※選択した曜日はロボが起動しません。
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-checkbox v-for="(ch, idx) in weekdayList" :key="idx" :native-value="idx" v-model="holidayList">
                {{ch}}
              </b-checkbox>
            </div>
          </div>
          <div class="tab-box-form">
            <div class="tab-box-left" style="flex-wrap: wrap;">
              <p><b>祝日</b>
                <br>
                <span style="color: #666; font-size: 12px;">
                  ※ONにすると祝日はロボが起動しません。
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-switch style="width: 100%;" size="is-small" v-model="isPublicHoliday">
              </b-switch>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="updateSitemap()" v-if="activeTab==0" :disabled="isContentsLoading">保存する</button>
      <button class="button is-primary" @click="updateWorkingTime()" v-else :disabled="isContentsLoading">保存する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import {
  SITEMAP_OVERALL,
  SITEMAP_ACTION_TYPE
} from '@/functions/users/sitemapFunc'
export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    chatbot: {
      type: Object,
      required: true
    }
  },
  computed: {
  },
  data () {
    return {
      isContentsLoading: false,
      sitemapRecruitList: [],
      sitemapCustomList: [],
      sitemapRootList: [],
      selectSitemapList: [],
      initSelectSitemapList: [],
      selectRecruitList: [],
      selectCustomList: [],
      initselectRecruitList: [],
      initSelectCustomList: [],
      recruitTotal: 0,
      customTotal: 0,
      total: 0,
      tabIdx: 0,
      pageData: {
        pages  : SITEMAP_OVERALL.PAGES,
        per_page: SITEMAP_OVERALL.PER_PAGE,
        content_type: 0
      },
      isAllSelectedRecruit: false,
      isAllSelectedCustom: false,
      isAllSelectedHomePage: false,
      miniIDX: 0,
      weekdayList: [
        '月', '火', '水', '木', '金', '土', '日'
      ],
      activeTab: 0,
      isAllDay: true,
      holidayList: [],
      isPublicHoliday: false,
      start: new Date(2000, 1, 1, 0, 0),
      end: new Date(2000, 1, 1, 0, 0)
    }
  },
  mounted () {
    if (this.isMiniBot(this.chatbot)) {
      this.init(this.chatbot.chatbot_mini[this.miniIDX])
    } else {
      this.init(this.chatbot)
    }
  },
  watch: {
    'pageData.pages' () {
      if (this.tabIdx === -1) {
        this.pageData.content_type = 4
        this.$store.dispatch('sitemap/getSitemapRecruitList', this.pageData)
          .then((data) => {
            this.sitemapRecruitList = data.sitemap_employment_list
            this.recruitTotal = data.total_count
            // URLを挿入していく
            for (const recruit of this.sitemapRecruitList) {
              for (const robo of recruit.apply_robo_list.concat(recruit.apply_minirobo_list)) {
                if (robo.data.bot_id === this.chatbot.bot_id) {
                  this.selectRecruitList.push(recruit)
                  this.initselectRecruitList.push(recruit)
                }
              }
            }
          })
      } else if (this.tabIdx === -2) {
        this.pageData.content_type = 5
        this.$store.dispatch('sitemap/getSitemapCustomList', this.pageData)
          .then((data) => {
            this.sitemapCustomList = data.sitemap_employment_list
            this.customTotal = data.total_count
          })
      }
    },
    tabIdx () {
      if (this.tabIdx === -1) {
        this.total = this.recruitTotal
      } if (this.tabIdx === -2) {
        this.total = this.customTotal
      }
    },
    isShowModal () {
      if (this.isMiniBot(this.chatbot)) {
        this.init(this.chatbot.chatbot_mini[this.miniIDX])
      } else {
        this.init(this.chatbot)
      }
    }
  },
  methods: {
    // 初期化、ミニロボ切り替え時
    init (chatbot) {
      // 初期化
      this.activeTab = 0
      // 起動場所初期化
      this.isContentsLoading = true
      this.selectSitemapList = []
      this.selectRecruitList = []
      this.initSelectSitemapList = []
      this.initselectRecruitList = []
      this.isAllSelectedRecruit = false
      this.isAllSelectedCustom = false
      this.isAllSelectedHomePage = false
      this.$store.dispatch('sitemap/getSitemapRootList')
        .then((data) => {
          this.sitemapRootList = data.sitemap_root_list
          // URLを挿入していく
          for (const root of this.sitemapRootList) {
            for (const sitemap of root.node_list) {
              for (const robo of sitemap.apply_robo_list.concat(sitemap.apply_minirobo_list)) {
                if (robo.data.bot_id === chatbot.bot_id) {
                  this.selectSitemapList.push(sitemap)
                  this.initSelectSitemapList.push(sitemap)
                }
              }
            }
          }
          this.isContentsLoading = false
        })
      this.pageData.content_type = 4
      this.$store.dispatch('sitemap/getSitemapRecruitList', this.pageData)
        .then((data) => {
          this.sitemapRecruitList = data.sitemap_employment_list
          this.recruitTotal = data.total_count
          // URLを挿入していく
          for (const recruit of this.sitemapRecruitList) {
            for (const robo of recruit.apply_robo_list.concat(recruit.apply_minirobo_list)) {
              if (robo.data.bot_id === chatbot.bot_id) {
                this.selectRecruitList.push(recruit)
                this.initselectRecruitList.push(recruit)
              }
            }
          }
        })
      this.pageData.content_type = 5
      this.$store.dispatch('sitemap/getSitemapCustomList', this.pageData)
        .then((data) => {
          this.sitemapCustomList = data.sitemap_employment_list
          this.customTotal = data.total_count
          // URLを挿入していく
          for (const custom of this.sitemapCustomList) {
            for (const robo of custom.apply_robo_list.concat(custom.apply_minirobo_list)) {
              if (robo.data.bot_id === chatbot.bot_id) {
                this.selectCustomList.push(custom)
                this.initSelectCustomList.push(custom)
              }
            }
          }
        })

      // 起動時間初期化
      this.isAllDay = this.chatbot.working_hours['is_all_day']
      this.holidayList = this.chatbot.working_hours['holiday_list']
      this.isPublicHoliday = this.chatbot.working_hours['is_public_holiday']
      this.start = new Date(2000, 1, 1,
        this.chatbot.working_hours['work_time_start'].substr(0,2),
        this.chatbot.working_hours['work_time_start'].substr(3))
      this.end = new Date(2000, 1, 1,
        this.chatbot.working_hours['work_time_end'].substr(0,2),
        this.chatbot.working_hours['work_time_end'].substr(3))
    },
    // ミニロボ有無チェック
    isMiniBot (chatbot) {
      let isMini = false
      if (chatbot.chatbot_mini) {
        if (chatbot.chatbot_mini.length > 0) {
          isMini = true
        }
      }
      return isMini
    },
    cancel () {
      this.$emit('cancel', false)
    },
    getAllUrl (idx) {
      if (idx >= 0 && this.sitemapRootList) {
        if (this.isAllSelectedHomePage) {
          this.selectSitemapList = this.$_.union(this.selectSitemapList, this.sitemapRootList[idx].node_list)
        } else {
          this.selectSitemapList = this.$_.difference(this.selectSitemapList, this.sitemapRootList[idx].node_list)
        }
      } else if (idx === -1 && this.sitemapRecruitList) {
        // 求人ページ
        if (this.isAllSelectedRecruit) {
          this.selectRecruitList = this.$_.union(this.selectRecruitList, this.sitemapRecruitList)
        } else {
          this.selectRecruitList = this.$_.difference(this.selectRecruitList, this.sitemapRecruitList)
        }
      } else if (idx === -2 && this.sitemapCustomList) {
        // カスタムページ
        if (this.isAllSelectedCustom) {
          this.selectCustomList = this.$_.union(this.selectCustomList, this.sitemapCustomList)
        } else {
          this.selectCustomList = this.$_.difference(this.selectCustomList, this.sitemapCustomList)
        }
      }
    },
    updateSitemap () {
      let updateData = {
        update_list: [],
        action     : SITEMAP_ACTION_TYPE.ROBO_APPLY,
        is_mini    : this.isMiniBot(this.chatbot),
      }
      let deleteData = {
        update_list: [],
        action     : SITEMAP_ACTION_TYPE.ROBO_UNAPPLY,
        is_mini    : this.isMiniBot(this.chatbot),
      }
      let robo = null
      if (this.isMiniBot(this.chatbot)) {
        robo = {
          data: {
            'pk'           : this.chatbot.chatbot_mini[this.miniIDX].bot_id,
            'name'         : this.chatbot.chatbot_mini[this.miniIDX].name,
            'bot_id'       : this.chatbot.chatbot_mini[this.miniIDX].bot_id,
            'scenario_name': this.chatbot.scenario_name,
          },
          is_mini: true
        }
      } else {
        robo = {
          data: {
            'pk'           : this.chatbot.bot_id,
            'name'         : this.chatbot.name,
            'bot_id'       : this.chatbot.bot_id,
            'scenario_name': this.chatbot.scenario_name,
          },
          is_mini: false
        }
      }

      // 差集合で新規更新と削除を見る
      let createSitemapList = this.$_.difference(this.selectSitemapList, this.initSelectSitemapList)
      let deleteSitemapList = this.$_.difference(this.initSelectSitemapList, this.selectSitemapList)
      // 差集合で新規更新と削除を見る
      let createRecruitList = this.$_.difference(this.selectRecruitList, this.initselectRecruitList)
      let deleteRecruitList = this.$_.difference(this.initselectRecruitList, this.selectRecruitList)
      // 差集合で新規更新と削除を見る
      let createCustomList = this.$_.difference(this.selectCustomList, this.initSelectCustomList)
      let deleteCustomList = this.$_.difference(this.initSelectCustomList, this.selectCustomList)
      if (createSitemapList.length > 0) {
        updateData.update_list = []
        for (const sitemap of createSitemapList) {
          let updatePath = {
            target   : sitemap,
            robo     : [robo]
          }
          updateData.update_list.push(updatePath)
        }
        this.$store.dispatch('sitemap/updateSitemapNode', {
          update_data: updateData
        })
      }
      if (createRecruitList.length > 0) {
        updateData.update_list = []
        for (const recruit of createRecruitList) {
          let updatePath = {
            target   : recruit,
            robo     : [robo]
          }
          updateData.update_list.push(updatePath)
        }
        this.$store.dispatch('sitemap/updateSitemapEmployment', {
          update_data: updateData,
          page_data  : this.pageData
        })
      }
      if (createCustomList.length > 0) {
        updateData.update_list = []
        for (const custom of createCustomList) {
          let updatePath = {
            target   : custom,
            robo     : [robo]
          }
          updateData.update_list.push(updatePath)
        }
        this.$store.dispatch('sitemap/updateSitemapEmployment', {
          update_data: updateData,
          page_data  : this.pageData
        })
      }
      if (deleteSitemapList.length > 0) {
        deleteData.update_list = []
        for (const sitemap of deleteSitemapList) {
          let updatePath = {
            target   : sitemap,
            robo     : [robo]
          }
          deleteData.update_list.push(updatePath)
        }
        this.$store.dispatch('sitemap/updateSitemapNode', {
          update_data: deleteData
        })
          .then((data) => {
            this.sitemapRootList = data.sitemap_root_list
            // URLを挿入していく
            for (const root of this.sitemapRootList) {
              for (const sitemap of root.node_list) {
                for (const robo of sitemap.apply_robo_list.concat(sitemap.apply_minirobo_list)) {
                  if (robo.data.bot_id === this.chatbot.bot_id) {
                    this.selectSitemapList.push(sitemap)
                    this.initSelectSitemapList.push(sitemap)
                  }
                }
              }
            }
            this.isContentsLoading = false
          })
      }
      if (deleteRecruitList.length > 0) {
        deleteData.update_list = []
        for (const recruit of deleteRecruitList) {
          let updatePath = {
            target   : recruit,
            robo     : [robo]
          }
          deleteData.update_list.push(updatePath)
        }
        this.pageData.content_type = 4
        this.$store.dispatch('sitemap/updateSitemapEmployment', {
          update_data: deleteData,
          page_data  : this.pageData
        })
          .then((data) => {
            this.sitemapRecruitList = data.sitemap_employment_list
            this.recruitTotal = data.total_count
            // URLを挿入していく
            for (const recruit of this.sitemapRecruitList) {
              for (const robo of recruit.apply_robo_list.concat(recruit.apply_minirobo_list)) {
                if (robo.data.bot_id === this.chatbot.bot_id) {
                  this.selectRecruitList.push(recruit)
                  this.initselectRecruitList.push(recruit)
                }
              }
            }
          })
      }
      if (deleteCustomList.length > 0) {
        deleteData.update_list = []
        for (const custom of deleteCustomList) {
          let updatePath = {
            target   : custom,
            robo     : [robo]
          }
          deleteData.update_list.push(updatePath)
        }
        this.pageData.content_type = 5
        this.$store.dispatch('sitemap/updateSitemapEmployment', {
          update_data: deleteData,
          page_data  : this.pageData
        })
          .then((data) => {
            this.sitemapCustomList = data.sitemap_employment_list
            this.customTotal = data.total_count
            // URLを挿入していく
            for (const custom of this.sitemapCustomList) {
              for (const robo of custom.apply_robo_list.concat(custom.apply_minirobo_list)) {
                if (robo.data.bot_id === this.chatbot.bot_id) {
                  this.selectCustomList.push(custom)
                  this.initSelectCustomList.push(custom)
                }
              }
            }
          })
      }
      this.$store.dispatch('chatbot/getChatBots')
      this.$emit('cancel', false)
    },
    updateWorkingTime() {
      let startTime = ''
      let endTime   = ''
      startTime = ("0" + this.start.getHours()).slice(-2) + ":" + ("0" + this.start.getMinutes()).slice(-2)
      endTime   = ("0" + this.end.getHours()).slice(-2)   + ":" + ("0" + this.end.getMinutes()).slice(-2)
      this.chatbot.working_hours['work_time_start'] = startTime
      this.chatbot.working_hours['work_time_end']   = endTime
      this.chatbot.working_hours['is_all_day'] = this.isAllDay
      this.chatbot.working_hours['holiday_list'] = this.holidayList
      this.chatbot.working_hours['is_public_holiday'] = this.isPublicHoliday
      this.$store.dispatch('chatbot/setChatBot', this.chatbot)
      for (var i of this.chatbot.chatbot_mini) {
        i.working_hours = this.chatbot.working_hours
        this.$store.dispatch('chatbot/updateChatBotMini', i)
      }
      this.$emit('cancel', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.url-container {
  padding: 8px;
}
::-webkit-scrollbar {
  width:  15px;
  height: 15px;
  visibility: hidden;
}
.tab-box-form {
  width: 100%; display: flex; padding: 8px;
  flex-wrap: wrap;
}
.tab-box-left {
  width: 40%; display: flex; justify-content: flex-start; align-items: center;
  border-right: solid 2px #ccc; padding-left: 8px;
}
.tab-box-right {
  width: 60%; font-size: 13px; padding: 10px 10px 10px 18px; justify-content: flex-start; display: flex;
  flex-wrap: wrap;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailURLSetting.vue